module.exports = {
    webpack_path: 'http://localhost:3000/ra/',
    webpack_host: 'localhost',
    port: 3000,
    websocket_port: ":7777"
};
